export default "__VITE_ASSET__v$jLK$R2__"